import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BaseDateRangeSelectorComponent } from '../base-date-range-selector/base-date-range-selector.component';

@Component({
  selector: 'app-monthly-date-range-selector',
  templateUrl: './monthly-date-range-selector.component.html',
  styleUrls: ['./monthly-date-range-selector.component.css']
})
export class MonthlyDateRangeSelectorComponent extends BaseDateRangeSelectorComponent implements OnInit {

  monthOptions: Array<any> = new Array<any>();
  yearOptions: Array<number> = new Array<number>();

  beginYear: number;
  beginMonth: any;

  endYear: number;
  endMonth: any;

  constructor(
    formBuilder: FormBuilder
  )
  {
    super(formBuilder);

    var curdate = new Date();

    var yearNow = curdate.getFullYear();

    for (var i = yearNow; i > yearNow - 20; i--) {
      this.yearOptions.push(i);
    }

    const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    for (var i = 0; i < monthNames.length; i++) {
      var monthOpt = {
        name: monthNames[i],
        number: (i)
      };

      this.monthOptions.push(monthOpt);
    }

    var oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

    var lastYear = new Date();
    lastYear.setMonth(lastYear.getMonth() - 12);

    this.endYear = oneMonthAgo.getFullYear();
    this.endMonth = this.monthOptions[oneMonthAgo.getMonth()];

    this.beginYear = lastYear.getFullYear();
    this.beginMonth = this.monthOptions[lastYear.getMonth()];
  }

  ngOnInit(): void {

    super.ngOnInit();

    //Add form controls that are specific to our year/month scenario
    this.dateBoundsSelectionForm.addControl("FromYear", new FormControl(this.beginYear, []));
    this.dateBoundsSelectionForm.addControl("FromMonth", new FormControl(this.beginMonth, []));
    this.dateBoundsSelectionForm.addControl("ToYear", new FormControl(this.endYear, []));
    this.dateBoundsSelectionForm.addControl("ToMonth", new FormControl(this.endMonth, []));

    this.dateBoundsSelectionForm.get("FromYear").valueChanges.subscribe(selectedValue => {
      this.beginYear = selectedValue;
      this.updateBeginDate();
    });

    this.dateBoundsSelectionForm.get("FromMonth").valueChanges.subscribe(selectedValue => {
      this.beginMonth = selectedValue;
      this.updateBeginDate();
    });

    this.dateBoundsSelectionForm.get("ToYear").valueChanges.subscribe(selectedValue => {
      this.endYear = selectedValue;
      this.updateEndDate();
    });

    this.dateBoundsSelectionForm.get("ToMonth").valueChanges.subscribe(selectedValue => {
      this.endMonth = selectedValue;
      this.updateEndDate();
    });

    this.dateBoundsSelectionForm.controls.FromYear.setValue(this.beginYear);
    this.dateBoundsSelectionForm.controls.FromMonth.setValue(this.beginMonth);

    this.dateBoundsSelectionForm.controls.ToYear.setValue(this.endYear);
    this.dateBoundsSelectionForm.controls.ToMonth.setValue(this.endMonth);
  }

  setToLastDayOfMonth(date) {
    // Create a new Date object for the first day of the next month
    const year = date.getFullYear();
    const month = date.getMonth();
    const nextMonth = new Date(year, month + 1, 1);

    // Subtract one day to get the last day of the current month
    const lastDayOfMonth = new Date(nextMonth.getTime() - 1);

    // Update the original date with the last day of the month
    date.setDate(lastDayOfMonth.getDate());

    return date;
  }

  updateEndDate() {
    var date = new Date();
    date.setFullYear(this.endYear);
    date.setMonth(this.endMonth.number);
    date.setDate(1);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    date = this.setToLastDayOfMonth(date);

    this.endDate = date;
    if (this.dateBoundsSelectionForm != null) {
      this.dateBoundsSelectionForm.controls.EndDate.setValue(date);
    }
  }

  updateBeginDate() {
    var date = new Date();
    date.setFullYear(this.beginYear);
    date.setMonth(this.beginMonth.number);
    date.setDate(1);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);

    this.beginDate = date;

    if (this.dateBoundsSelectionForm != null) {
      this.dateBoundsSelectionForm.controls.BeginDate.setValue(date);
    }
  }
}
